<div class="fixed bottom-5 right-5 z-50 flex flex-col-reverse gap-2">
    @for (alert of alerts; track alert.id) {
        <app-alert-card
            [alert]="alert"
            (removeAlert)="removeAlert($event)"
        ></app-alert-card>
    }
</div>
